import React from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { businessApi } from "../../lib/api";

export default function BusinessChangePasswordPage() {
  const nav = useNavigate();
  const ctx = useOutletContext() || {};
  const [cur, setCur] = React.useState("");
  const [pw, setPw] = React.useState("");
  const [pw2, setPw2] = React.useState("");
  const [busy, setBusy] = React.useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) { toast.error("Mindst 8 tegn"); return; }
    if (pw !== pw2) { toast.error("Kodeordene matcher ikke"); return; }
    setBusy(true);
    try {
      await businessApi().post("/business/auth/change-password", { current_password: cur, new_password: pw });
      toast.success("Kodeord opdateret");
      if (ctx.reload) await ctx.reload();
      nav("/business/dashboard", { replace: true });
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Kunne ikke ændre kodeord");
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto" data-testid="business-change-password-page">
      <h1 className="font-display font-bold text-2xl text-brand-dark mb-4">Skift kodeord</h1>
      {ctx?.user?.must_change_password && (
        <div className="bg-amber-50 border border-amber-200 p-3 text-sm text-amber-900 mb-4" data-testid="biz-must-change-banner">
          Du skal vælge et nyt kodeord før du kan fortsætte.
        </div>
      )}
      <form onSubmit={submit} className="bg-white border border-brand p-6 space-y-3">
        <div>
          <label className="label-flat">Nuværende kodeord</label>
          <input className="input-flat" type="password" required value={cur} onChange={(e) => setCur(e.target.value)} data-testid="biz-cp-current"/>
        </div>
        <div>
          <label className="label-flat">Nyt kodeord (min. 8 tegn)</label>
          <input className="input-flat" type="password" required minLength={8} value={pw} onChange={(e) => setPw(e.target.value)} data-testid="biz-cp-new"/>
        </div>
        <div>
          <label className="label-flat">Gentag nyt kodeord</label>
          <input className="input-flat" type="password" required minLength={8} value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="biz-cp-new2"/>
        </div>
        <button type="submit" disabled={busy} className="btn-primary w-full justify-center" data-testid="biz-cp-submit">
          {busy ? <Loader2 className="animate-spin" size={14}/> : "Gem"}
        </button>
      </form>
    </div>
  );
}
